export function talkTime() {
  // 获取当前时间
  const now = new Date();
  // 获取年、月、日、时、分、秒
  // const year = now.getFullYear();
  // const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份从0开始，所以要加1
  // const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  // 格式化时间为 YYYY-MM-DD HH:MM:SS
  // const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return `${hours}:${minutes}:${seconds}`;
}

export function extractPicUrlValue(str) {
  const regex = /"picUrl":\s*"([^"]*)"/;
  const match = str.match(regex);
  if (match && match[1]) {
    return match[1];
  } else {
    return null;
  }
}

export function extractContentValue(str) {
  const regex = /"content":\s*"(.*?)(?="|$)/;
  const match = str.match(regex);
  if (match && match[1]) {
    return match[1];
  } else {
    return str;
  }
}

// 去除字符串中的回车和空格等空白字符
export function clearChat(str) {
  if (!str || str.length <= 1) return "";
  str = str.replace(/\\r/g, "");
  str = str.replace(/\\n/g, "");
  str = str.replace(/\*\*/g, "");
  //去掉所有的空格（中文空格、英文空格都会被替换）
  str = str.replace(/\\s/g, "");
  str = str.replace(/\"\s*\}/g, "");
  return str.replace(/\\/g, "");
}

// 按照长度分割字符串
export function splitString(str) {
  if (!str) return [];
  const delimiterPattern = /([^，；、。？！\s]+[，；、。？！])/g; // 捕获组用于保留符号
  const segments = [];
  let match;

  // 使用正则表达式匹配并分割文本
  while ((match = delimiterPattern.exec(str)) !== null) {
    segments.push(match[0].trim()); // 将匹配到的内容加入结果数组
  }

  return segments;
}

export class StringProcessor {
  constructor(len) {
    this.len = len; // 固定长度
    this.tempStr = ""; // 缓存未处理的字符串
  }

  // 接收新的字符串
  receiveStr(newString) {
    // 将新字符串添加到缓存
    this.tempStr += newString;
    this.temp += newString;
    return this.processTemp();
  }
  // 处理缓存中的字符串
  processTemp() {
    const result = [];
    // 当缓存长度大于等于固定长度时，进行截取
    while (this.tempStr.length >= this.len) {
      // 截取固定长度的字符串
      result.push(this.tempStr.slice(0, this.len));
      this.tempStr = this.tempStr.slice(this.len);
    }
    return result; // 返回处理后的结果
  }
}

// 见流式输出的内容按照固定分隔符，成句输出
export const delimiter = ["，", ",", "。", "?", "？", "！", "!", ";", "；", '",', "😉", "\n", "~"];

// 终端词语
export const terminalWords = [
  "图图",
  "突突",
  "土土",
  "涂涂",
  "秃秃",
  "凸凸",
  "徒徒",
  "屠屠",
  "途途",
  "涂途",
  "途涂",
  "图涂",
  "途图",
  "徒途",
  "途徒",
];

// 截取大模型中断asr话语
export function extractAsrContent(str) {
  return str.replace("[[END_ASR]]", "").replace("[[END_ASR]]", "").trim().replace("[[END_DIRECT]]", "");
}

// AbortSignal.any 封装
export function mergeSignals(signals) {
  const controller = new AbortController();

  function onAbort(event) {
    controller.abort(event?.target?.reason);
    cleanup();
  }

  function cleanup() {
    signals.forEach((signal) => signal.removeEventListener("abort", onAbort));
  }

  signals.forEach((signal) => {
    if (signal.aborted) {
      controller.abort(signal.reason);
    } else {
      signal.addEventListener("abort", onAbort);
    }
  });

  return controller.signal;
}

// 文本展示优化：替换同音词，去除多余空格等
export function normalizeText(str) {
  return str.replace(/数据([^A-Za-z\u4e00-\u9fa5]*)要素/g, "数据要素");
}

export function replaceAsrContent(pinyin, text) {
  const targets = ["shu ju yao su cheng", "shu ju yao su chen"];
  const hit = targets.some((tp) => pinyin.includes(tp));
  if (hit && text.includes("数据要素")) {
    text = text.replace(/数据要素./g, "数据要素x");
  }
  if (pinyin.includes("ren gong zhi neng jia") && text.includes("人工智能")) {
    text = text.replace(/人工智能./g, "人工智能+");
  }
  return normalizeText(text);
}

// 语音播报改变
export function replaceTTS(str) {
  return str
    .replace(/数据要素[xX×]/g, "数据要素乘")
    .replace(/天聚地合/g, "天聚第合")
    .replace(/人工智能[+]/g, "人工智能加");
}
